//#region Styles
import {
    Container, 
    Content, 
    StyledTextArea, 
    CharCounter 
} from "./styles";
import { BottomPart } from "components/styles";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion

const CustomTextArea = ({
    value = "", 
    label, 
    placeholder, 
    maxLength, 
    onChange, 
    errorText, 
    width = "100%",
    height,
    showCharCounter = true,
    error = false,
    disabled
}) => {
    const getClassName = () => {
        const classList = [
            disabled && "disabled",
            error && "error"
        ];
        return classList.join(" ");
    }
    const className = getClassName();
    return (
        <Container className={className} width={width}>
            <label>
                {label}
            </label>
            <Content className={className}>
                <StyledTextArea
                    value={value}
                    onChange={({ target }) => onChange(target.value)}
                    placeholder={placeholder}
                    height={height}
                    maxLength={maxLength}
                    className={showCharCounter ? "" : "no-border"}
                    disabled={disabled}></StyledTextArea>
                {showCharCounter &&
                <BottomPart className={className}>
                    <ErrorMessage 
                        error={error}
                        text={errorText}/>
                    <CharCounter>
                        Caracteres: {value.length}/{maxLength}
                    </CharCounter>
                </BottomPart>}
            </Content>
            {!showCharCounter && 
            <ErrorMessage 
                error={error}
                text={errorText}/>}
        </Container>
    );
}

export default CustomTextArea;